/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RenderEditableLabelers from './gridComponents/RenderEditableLabelers';
import SelectNewLabelerModal from './SelectNewLabelerModal';
import TableGrid from '../../../../SharedModules/Table/tableGrid';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';

import { MinDate } from '../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { validDate } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getSearchLabelers,
  deleteLabelersData,
  maintainLabelerListData,
  setNewLabelersListAction,
} from '../store/ManufacturerAction';

export default function ManufacturerLabelers(props) {
  const dispatch = useDispatch();
  const {
    createMFG,
    data,
    disabledSaveCancelBtn,
    cellHead,
    selectMFGData,
    setGridApi,
    setColumnApi,
    errorMessages,
    totalResultCount,
    permanentDeleteLabelerList,
    setDisabledSaveCancelBtn,
    setSuccessMessage,
    setTotalResultCount,
    setErrorMessages,
    onFilterChanged,
    addEditReduxDataManufacturerTab,
    addEditManufacturerTabData,
    isEnablebyRole,
  } = props;
  const addEditManufacturerLabelersData = (value, action) => {
    dispatch(maintainLabelerListData(value, action));
  };

  const deleteManufacturerLabelers = (index, data) => {
    dispatch(deleteLabelersData(index, data));
  };
  const fetchSearchLabelerList = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.searchLabelerList;
  });
  const labelerRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.labelersList;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });

  const containerStyle = useMemo(() => ({ width: '100%', height: '80%' }), []);
  const [rowData, setRowData] = React.useState(data);
  const [columnDefs] = React.useState(cellHead);
  const [index, setIndex] = React.useState(null);
  const [selectRow, setSelectRow] = React.useState({});
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [deletePopup, setDeletePopup] = React.useState(false);
  const [gridParams, setGridParams] = React.useState(null);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setGridParams(params);
  }, []);
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        labelerRowData &&
        labelerRowData?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(maintainLabelerListData(tempObj, 'verify'));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  }, [commentsList]);
  // set row data
  React.useEffect(() => {
    setRowData(data);
  }, [data]);
  // open delete popup
  const handleOpen = () => {
    setOpen(true);
    dispatch(getSearchLabelers(null));
  };
  // set error message
  const errorMessagesArray = [...errorMessages];
  // delete
  const deleteSelectRowData = (index, data) => {
    const temp =
      labelerRowData &&
      labelerRowData.length > 0 &&
      labelerRowData.map((item, key) => {
        if (key === index) {
          item.startDateErr = false;
          item.endDateErr = false;
        }
        return item;
      });
    addEditManufacturerLabelersData(temp, 'verify');
    setSelectRow(null);
    setIndex(null);
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    const result = new Promise(() => {
      handleOnblurEvent();
      deleteManufacturerLabelers(index, data);
    });
    if (permanentDeleteLabelerList && data.permanentDelete) {
      const newObj = [...permanentDeleteLabelerList];
      newObj.push(data);
      props.setPermanentDeleteLabelerList(newObj);
      addEditReduxDataManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: false,
        permanentDeleteLabelerList: newObj,
      });
    }
  };
  // call on Blur event after filed value change
  const handleOnblurEvent = () => {
    setDisabledSaveCancelBtn(false);
    addEditReduxDataManufacturerTab({
      ...addEditManufacturerTabData,
      disabledSaveCancelBtn: false,
    });
    handleOnblurEndDateEvent();
    setSuccessMessage([]);
    if (
      labelerRowData &&
      labelerRowData.length > 0 &&
      labelerRowData.filter((x) => {
        return x.startDateErr;
      }).length > 0
    ) {
      labelerRowData.map((row) => {
        if (
          row.startDate !== null &&
          row.startDate !== '' &&
          validDate(new Date(row.startDate)) === false
        ) {
          errorMessagesArray &&
            errorMessagesArray.length > 0 &&
            errorMessagesArray.map((item, key) => {
              if (item === constantMessageData.START_DATE_REQUIRED) {
                return (
                  errorMessagesArray.splice(key, 1),
                  setErrorMessages([...new Set(errorMessagesArray)]),
                  addEditReduxDataManufacturerTab({
                    ...addEditManufacturerTabData,
                    disabledSaveCancelBtn: false,
                    errorMessages: [...new Set(errorMessagesArray)],
                  })
                );
              }
            });
          return (
            errorMessagesArray.push(
              constantMessageData.DATE_INVALID_FORMAT_ERROR
            ),
            props.setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              disabledSaveCancelBtn: false,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }
        if (
          row.startDate !== null &&
          row.startDate !== '' &&
          compareTwoDatesGreaterThanOrEqual(
            new Date(row.startDate),
            moment.utc(MinDate)
          )
        ) {
          return (
            errorMessagesArray &&
              errorMessagesArray.length > 0 &&
              errorMessagesArray.map((item, key) => {
                if (item === constantMessageData.DATE_INVALID_FORMAT_ERROR) {
                  return (
                    errorMessagesArray.splice(key, 1),
                    setErrorMessages([...new Set(errorMessagesArray)]),
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      disabledSaveCancelBtn: false,
                      errorMessages: [...new Set(errorMessagesArray)],
                    })
                  );
                }
              }),
            errorMessagesArray.push(constantMessageData.MFG_START_DATE_ERROR),
            props.setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              disabledSaveCancelBtn: false,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }
      });
    } else if (
      (labelerRowData &&
        labelerRowData.length > 0 &&
        labelerRowData.filter((x) => {
          return x.endDateErr;
        }).length > 0) === false
    ) {
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.map((item, key) => {
          if (
            item === constantMessageData.DATE_INVALID_FORMAT_ERROR ||
            item === constantMessageData.MFG_START_DATE_ERROR ||
            item === constantMessageData.START_DATE_REQUIRED
          ) {
            return (
              errorMessagesArray.splice(key, 1),
              props.setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    }
  };
  // call on Blur event after date filed level
  const handleOnblurEndDateEvent = () => {
    if (
      labelerRowData &&
      labelerRowData.length > 0 &&
      labelerRowData.filter((x) => {
        return x.endDateErr;
      }).length > 0
    ) {
      labelerRowData.map((row) => {
        if (
          row.endDate !== null &&
          row.endDate !== '' &&
          validDate(new Date(row.endDate)) === false
        ) {
          return (
            errorMessagesArray.push(
              constantMessageData.DATE_INVALID_FORMAT_ERROR
            ),
            props.setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }
        if (
          row.endDate !== null &&
          row.endDate !== '' &&
          compareTwoDatesGreaterThanOrEqual(
            new Date(row.endDate),
            moment.utc(new Date(row.startDate))
          )
        ) {
          const result = new Promise(() => {
            errorMessagesArray &&
              errorMessagesArray.length > 0 &&
              errorMessagesArray.map((item, key) => {
                if (
                  item === constantMessageData.DATE_INVALID_FORMAT_ERROR &&
                  validDate(row.endDate)
                ) {
                  return (
                    errorMessagesArray.splice(key, 1),
                    setErrorMessages([...new Set(errorMessagesArray)]),
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      errorMessages: [...new Set(errorMessagesArray)],
                    })
                  );
                }
              });
          });
          return (
            errorMessagesArray.push(
              constantMessageData.MFG_LABELER_END_DATE_ERROR
            ),
            props.setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }
      });
    } else if (
      (labelerRowData &&
        labelerRowData.length > 0 &&
        labelerRowData.filter((x) => {
          return x.startDateErr;
        }).length > 0) === false
    ) {
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.map((item, key) => {
          if (
            item === constantMessageData.MFG_LABELER_END_DATE_ERROR ||
            item === constantMessageData.DATE_INVALID_FORMAT_ERROR
          ) {
            return (
              errorMessagesArray.splice(key, 1),
              props.setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                disabledSaveCancelBtn: false,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    }
  };
  // ag-grid frame work components
  const frameworkComponents = {
    DeleteBoxRender: (cellInfo) => {
      return (
        <div className='tdCell icon-btn-group'>
          {showComments ? (
            <Button
              onClick={() => {
                if (cellInfo.data.corrLinkId && !createMFG) {
                  setCorrLinkId(cellInfo.data.corrLinkId);
                  setShowComments(true);
                }
              }}
              tabIndex={'0'}
              onKeyDown={(e) => {
                // Handle Enter and Space key events
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // Prevents the default space scrolling behavior
                  if (cellInfo.data.corrLinkId && !createMFG) {
                    setCorrLinkId(cellInfo.data.corrLinkId);
                    setShowComments(true);
                  }
                }
              }}
              aria-label='Comment'
              className={`th-ic comment-ic ${
                parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                  ? 'frr-enabled-comment-btn'
                  : 'frr-disabled-comment-btn'
              }`}
              variant='text'
            >
              {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                <img alt='' src={CommentVisibleIcon} />
              ) : (
                <img alt='' src={CommentIcon} />
              )}
            </Button>
          ) : (
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
            >
              <Button
                onClick={() => {
                  if (cellInfo.data.corrLinkId && !createMFG) {
                    setCorrLinkId(cellInfo.data.corrLinkId);
                    setShowComments(true);
                  }
                }}
                tabIndex={'0'}
                onKeyDown={(e) => {
                  // Handle Enter and Space key events
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault(); // Prevents the default space scrolling behavior
                    if (cellInfo.data.corrLinkId && !createMFG) {
                      setCorrLinkId(cellInfo.data.corrLinkId);
                      setShowComments(true);
                    }
                  }
                }}
                disabled={
                  cellInfo.data.corrLinkId === null ||
                  createMFG ||
                  !isEnablebyRole
                }
                aria-label='Comment'
                className={`th-ic comment-ic ${
                  parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                    ? 'frr-enabled-comment-btn'
                    : 'frr-disabled-comment-btn'
                }`}
                variant='text'
              >
                {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                  <img alt='' src={CommentVisibleIcon} />
                ) : (
                  <img alt='' src={CommentIcon} />
                )}
              </Button>
            </OverlayTrigger>
          )}
          {selectMFGData.mfgTypeCd === 'C' ? (
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
            >
              <Button
                className='th-ic trash-blue'
                variant='text'
                disabled={!isEnablebyRole}
                onClick={() => {
                  if (isEnablebyRole) {
                    setDeletePopup(true);
                    setIndex(cellInfo.rowIndex);
                    setSelectRow(cellInfo.data);
                  }
                }}
                style={{
                  opacity: !isEnablebyRole ? 0.5 : 1,
                  cursor: !isEnablebyRole ? 'not-allowed' : 'pointer',
                }}
              >
                <SVGComponent iconName='Icon-delete' />
              </Button>
            </OverlayTrigger>
          ) : null}
        </div>
      );
    },
    StartDate: (cellInfo) => (
      <RenderEditableLabelers {...cellInfo} isEnablebyRole={isEnablebyRole} />
    ),
    EndDate: (cellInfo) => (
      <RenderEditableLabelers {...cellInfo} isEnablebyRole={isEnablebyRole} />
    ),
    labelerNameRender: (cellInfo) => {
      const name = cellInfo.data.labelerName;
      if (name && name.length > 30) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };
  return (
    <>
      <div data-testid='Manufacturer-Labeler'>
        <SaveCancelPopup
          open={deletePopup}
          title='Delete'
          moduleName='the selected record'
          onConfim={() => {
            setDeletePopup(false);
            deleteSelectRowData(index, selectRow);
          }}
          onCancel={() => {
            setDeletePopup(false);
          }}
        />

        <SelectNewLabelerModal
          dataList={fetchSearchLabelerList}
          open={open}
          createMFG={createMFG}
          disabledSaveCancelBtn={disabledSaveCancelBtn}
          handleClose={(value) => {
            setOpen(false);
            setDisabledSaveCancelBtn(value);
            if (!value && disabledSaveCancelBtn) {
              addEditReduxDataManufacturerTab({
                values: props.values,
                manufacturerDetail: props.manufacturerDetail,
                contactDetail: props.contactDetail,
                disabledSaveCancelBtn: false,
                tabValue: 'one',
                action: 'modify',
              });
            }
          }}
        />

        <div>
          {selectMFGData.mfgTypeCd === 'C' ? (
            <div className='float-right th-icon-group btn-plus mt-2'>
              <Link
                to='#'
                className={`icon-plus float-right ${!isEnablebyRole ? 'disabled-link' : ''}`}
                data-testid='add-labeler'
                type='button'
                onClick={(e) => {
                  if (!isEnablebyRole) {
                    e.preventDefault();
                  } else {
                    handleOpen();
                  }
                }}
                style={{
                  pointerEvents: !isEnablebyRole ? 'none' : 'auto',
                  opacity: !isEnablebyRole ? 0.5 : 1,
                  cursor: !isEnablebyRole ? 'not-allowed' : 'pointer',
                }}
              >
                <span>New Labelers</span>
              </Link>
            </div>
          ) : null}

          <div style={containerStyle}>
            <div className='clearfix' />
            <div className='panel-body FRR-custom-table tbl-manufacturer-inner'>
              <TableGrid
                onGridReady={onGridReady}
                ref={props.childRef}
                gridHeight={props.fullScreenView ? '70vh' : 400}
                rowData={
                  rowData && rowData.length > 0
                    ? rowData.map((prop) => {
                        if (
                          prop?.startDate &&
                          prop.startDate?.toString()?.includes('/')
                        ) {
                          prop.startDate =
                            prop.startDate?.toString()?.length > 10
                              ? prop.startDate?.substring(0, 10)
                              : prop.startDate;
                        } else if (prop.startDate) {
                          prop.startDate = moment
                            .utc(prop.startDate)
                            .format('MM/DD/yyyy');
                        }
                        if (
                          prop?.endDate &&
                          prop.endDate?.toString()?.includes('/')
                        ) {
                          prop.endDate =
                            prop.endDate?.toString()?.length > 10
                              ? prop.endDate?.substring(0, 10)
                              : prop.endDate;
                        } else if (prop.endDate) {
                          prop.endDate = moment
                            .utc(prop.endDate)
                            .format('MM/DD/yyyy');
                        }
                        return prop;
                      })
                    : []
                }
                columnDefs={columnDefs}
                onFilterChanged={onFilterChanged}
                frameworkComponents={frameworkComponents}
                onCellValueChanged={() => {
                  handleOnblurEvent();
                }}
                setTotal={setTotalResultCount}
                data-testid='onEditingStopped'
                fileName='Manufacturer-Labelers'
                navigateToNextCell={navigateToNextCell}
                // tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
              />
            </div>
          </div>
          <p className='total-results' tabIndex='0'>
            Total Results:<b>{totalResultCount?.toLocaleString('en-US')}</b>
          </p>
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='MFG_LABELER'
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={props.values && props.values.mfgId}
        />
      ) : null}
    </>
  );
}
